import { ModalContent, Tabs } from "@kyan/ui";

import { useIsEquityModalEditing } from "#/store/app/equityModal/equityModalEditState";
import { useEquityModalTab } from "#/store/app/equityModal/equityModalTab";
import { useShowBridgeHistory } from "#/store/app/equityModal/showBridgeHistory";
import { useAccountState } from "#/store/wallet/account/accountState";

import { DepositForm } from "./components/DepositForm/DepositForm";
import { TransferForm } from "./components/TransferForm/TransferForm";
import { WithdrawForm } from "./components/WithdrawForm/WithdrawForm";

export const EquityModalContent: React.FC = () => {
  const { equityModalTab, setEquityModalTab } = useEquityModalTab();
  const { hasEquitySomewhere } = useAccountState();
  const { showBridgeHistory } = useShowBridgeHistory();
  const { isEquityModalEditing } = useIsEquityModalEditing();

  return (
    <ModalContent
      exitDelay={0.1}
      shouldScroll={false}
      className="max-w-108.25 sm:bottom-auto"
      disableBackdropClick={isEquityModalEditing}
    >
      {hasEquitySomewhere && !showBridgeHistory ? (
        <Tabs
          variant="primary"
          value={equityModalTab}
          className="w-full max-w-80.5"
          contentClassName="w-full mt-4 overflow-auto"
          items={[
            {
              label: "Deposit",
              id: "deposit",
              content: <DepositForm />,
            },
            {
              label: "Transfer",
              id: "transfer",
              content: <TransferForm />,
            },
            {
              label: "Withdraw",
              id: "withdraw",
              content: <WithdrawForm />,
            },
          ]}
          onChange={setEquityModalTab}
        />
      ) : (
        <DepositForm isInitialDeposit={!hasEquitySomewhere} />
      )}
    </ModalContent>
  );
};
